<template>
  <v-dialog v-model="dialog" scrollable max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary">
        <v-icon>mdi-plus</v-icon>Create Task
      </v-btn>
    </template>
    <v-card>
      <v-card-title> Create Task </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="newTaskDetails.name"
            label="Task Name"
            :rules="[(v) => !!v || 'Task name is required.']"
            hint="The name of the new task."
            required
          />

          <v-textarea
            v-model="newTaskDetails.description"
            label="Description"
            :rules="[(v) => !!v || 'A description is required.']"
            required
            auto-grow
          />
          <v-select
            :items="qMatrices"
            item-text="name"
            item-value="id"
            v-model="newTaskDetails.q_matrix_id"
            label="Q-Matrix"
          >
          </v-select>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
        <v-btn :disabled="!valid" color="primary" text @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Bus } from '@/bus'

export default {
  name: 'TaskDialog',
  props: {
    qMatrices: Array
  },
  data () {
    return {
      valid: true,
      dialog: false,
      newTaskDetails: {}
    }
  },
  methods: {
    save () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        try {
          this.$store.dispatch('bcm/createBlueprintTask', this.newTaskDetails)
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: `Failed to create Task in Blueprint Content Manager`
          })
        } finally {
          this.$emit('task-saved')
          this.newTaskDetails = {}
          this.$refs.form.reset()
          this.dialog = false
        }
      }
    }
  }
}
</script>
